// extracted by mini-css-extract-plugin
export default {"container":"Switcher_container__esgd-","option":"Switcher_option__oNCWD","active":"Switcher_active__iIV1v"};